import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { IGoal } from "@gtmhub/goals/models";
import { Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "limitations-reached",
  templateUrl: "./limitations-reached.component.html",
  styleUrls: ["./limitations-reached.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitationsReachedComponent {
  @Input() public metricsLimit: number;
  @Input() public metricsLimitReached: boolean;
  @Input() public goal: IGoal;
  @Input() public session: Session;
  @Output() public readonly dismiss: EventEmitter<null> = new EventEmitter();
}
